import styled from "styled-components";
import * as Auth from "../shared/styles";
import { FieldWrapper } from "components/shared/form";
import queries, { devices } from "utils/responsivenessHelper";
import { StyledButton } from "components/button/styles";

const Container = styled(Auth.Container)`
  ${queries.both({ padding: "20% 0%" }, devices.mobile)}

  ${FieldWrapper} {
    width: 20.3125em;
    box-sizing: content-box;
    padding: 2% 4%;
    ${queries.both({ width: "85%", padding: "4%" }, devices.phone)}
  }

  ${StyledButton} {
    width: 17.125em;
    ${queries.both({ width: "55%" }, devices.phone)}
  }
`;

const ForgotPasswordWrapper = styled.div`
  font-size: 0.75rem;

  padding-bottom: 2em;
`;

export { Container, ForgotPasswordWrapper };
